var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-books-container"},[_c('ListHeader',{staticClass:"books-list-header",attrs:{"showSwitch":'paper',"listTitle":"我的数字报"},on:{"switchDataView":(val) => (_vm.dataView = val),"query-list":_vm.getBooks}}),_c('papers-published',{ref:"papersPublishedRef",attrs:{"dataView":_vm.dataView}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }